import { TopicId } from '~/dashboard/utils/learningPath.utils'
import { IntRange } from '~/shared/types/intRange.types'
import { homMethodsType } from '~/shared/types/studyTips.types'
import { AppLanguage } from '~/types/locale'

export interface BootcampModuleType {
  _id: string
  description: string[]
  isCompleted: boolean
  key: string
  name: string
}

export enum TutorialPlacement {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum TutorialArrowPosition {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export interface AvatarPng {
  url: string
  isUnder13: boolean
  isExists: boolean
  isLoading: boolean
  isDeprecatedUrl?: boolean
}

export interface BootcampSectionType {
  isCompleted: boolean
  key: string
  modules: BootcampModuleType[]
  title: string
}

export interface latestActivities {
  language: AppLanguage
  pageSize: IntRange<1, 30>
  pageNumber: number
  startDate?: string
  endDate?: string
}

export interface latestActivitiesData {
  result: latestActivitiesResultData[]
  total: number
}

export interface latestActivitiesResultData {
  activityCategory: string
  activityId: string
  createdAt: string
  path: string
  isShowGrade: boolean
  metaData: vccMetaData
}

export interface LearningPathColors {
  start: string
  stop: string
  faded: string
  colorMatrix: string
  fadedMatrix: string
  completedMatrix: string
  completed: string
  completedInnerIconOpacity: number
}

interface vccMetaData {
  module: number
  moduleName: string
  moduleProgress: number
  pageName: string
  subject: string
  subjectName: string
  subjectProgress: number
  topic: string
  topicName: string
  type: string
  activityNo: number
  chestKey: string
  chestName: string
  chestProgress: number
  elevatorKey: string
  elevatorName: string
  levelNo: number
  roomKey: string
  roomName: string
  moduleKey: string
  moduleValue: string
}

export interface GameLogoAspectRatio {
  width: number
  height: number
  className: string
}
export interface LearningTracksGradesData {
  type: LearningTracksTypes.GRADE
  gradeLevel: number
  gradeCode: string
  gradeLabel: string
  order: number
  title: string
}

export interface LearningTracksRawGradeData {
  createdAt: string
  grade: number
  type: LearningTracksTypes.GRADE
}

export interface LearningTracksBootcampData {
  type: LearningTracksTypes.BOOTCAMP
  title: string
  id: string
  topicId: TopicId
  mathPreview: string
  progress: number
  path: string
}

export interface LearningTracksData {
  missingMappingQuiz: boolean
}

export enum ArrowPosition {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export enum LatestActivitiesProducts {
  VCC = 'bootcamp',
  VCC_VIDEO = 'bootcampVideo',
  ESSENTIALS = 'mathEssentials',
  MATH_VAULT = 'mathVault',
  MULT_GAME = 'multgame',
  STACK_N_LOAD = 'stacknload',
  TREASURE_TRAIL = 'treasureTrail',
  WIND_SURFER = 'windSurfer',
}

export enum LearningTracksTypes {
  GRADE = 'grade',
  BOOTCAMP = 'task',
}

export enum TutorialProducts {
  EMPTY = '',
  AVATAR_TUTORIAL = 'avatarTutorial',
  MATH_TASK = 'mathTask',
  CURRICULUM_TUTORIAL_1 = 'curriculumTutorial1',
  CURRICULUM_TUTORIAL_2 = 'curriculumTutorial2',
}

export interface DashboardProps {
  homMethodsData: homMethodsType
}
